export const orgPrivacyAgreementsUrl = 'https://www.pingcap.cn/privacy-policy';
